import { login, verifyToken, newLogin } from "@/services/Auth";
import { isStandalone } from "@/utils/pwa";

function setUserPermissionsByGroup(user) {
    let userPermissions = {}
    let groups = user["groups"]
    userPermissions.isManagement = false
    userPermissions.isHourly = false
    userPermissions.isStudent = false
    userPermissions.isResearch = false
    userPermissions.isAdvancedResearch = false
    userPermissions.isSuperuser = false
    userPermissions.isAccountManager = false
    userPermissions.isAccountStaff = false
    userPermissions.isDev = false
    userPermissions.isResearchLead = false
    userPermissions.isAllCompanies = false
    userPermissions.isGenerateTimecard = false
    userPermissions.isEditClientWorkflow = false
    userPermissions.isViewClientWorkflow = false
    userPermissions.isEditUserWorkflow = false
    userPermissions.isViewUserWorkflow = false
    userPermissions.isExternalTimecard = false
    userPermissions.isInventory = false
    userPermissions.isInternal = false
    userPermissions.isAdvanced = false
    userPermissions.isExpenseInvoicing = false
    userPermissions.isExpenseAccounting = false
    userPermissions.isExpenseAdmin = false
    userPermissions.isExpenseApproverOverride = false
    userPermissions.isExpenseParticipation = false
    userPermissions.isExpenseClientView = false
    userPermissions.isViewEngagementsInvoices = false
    userPermissions.isBackOffice = false
    userPermissions.isBackOfficeRequest = false
    userPermissions.canAccessExpenseAccounting = false
    userPermissions.canAccessAccountingQueue = false
    userPermissions.canAccessClientExpenses = false
    userPermissions.isExternalExpenseOnly = false

    for(let i=0; i < groups.length; i++){
        if(groups.some(group => group.name === "management_group")){
            userPermissions.isManagement = true;
            userPermissions.isInternal = true;
            userPermissions.isAdvanced = true;
        }
        if(groups.some(group => group.name === "hourly_group")){
            userPermissions.isHourly = true;
            userPermissions.isInternal = true;
        }
        if(groups.some(group => group.name === "student_group")){
            userPermissions.isStudent = true;
        }
        if(groups.some(group => group.name === "research_group")){
            userPermissions.isResearch = true;
            userPermissions.isInternal = true;
        }
        if(groups.some(group => group.name === "advanced_research_group")){
            userPermissions.isAdvancedResearch= true;
            userPermissions.isInternal = true;
        }
        if(groups.some(group => group.name === "superuser_group")){
            userPermissions.isSuperuser = true;
            userPermissions.isInternal = true;
            userPermissions.isAdvanced = true;
        }
        if(groups.some(group => group.name === "account_manager_group")){
            userPermissions.isAccountManager = true;
            userPermissions.isInternal = true;
            userPermissions.isAdvanced = true;
        }
        if(groups.some(group => group.name === "account_staff_group")){
            userPermissions.isAccountStaff = true;
            userPermissions.isInternal = true;
        }
        if(groups.some(group => group.name === "dev_group")) {
            userPermissions.isDev = true;
            userPermissions.isInternal = true;
            userPermissions.isAdvanced = true;
        }
        if(groups.some(group => group.name === "research_lead_group")){
            userPermissions.isResearchLead = true;
            userPermissions.isInternal = true;
        }
        if(groups.some(group => group.name === "all_companies_group")) {
            userPermissions.isAllCompanies = true;
        }
        if(groups.some(group => group.name === "generate_timecard_group")){
            userPermissions.isGenerateTimecard = true;
            userPermissions.isInternal = true;
        }
        if(groups.some(group => group.name === "edit_client_workflow_group")){
            userPermissions.isEditClientWorkflow = true;
        }
        if(groups.some(group => group.name === "view_client_workflow_group")){
            userPermissions.isViewClientWorkflow = true;
        }
        if(groups.some(group => group.name === "edit_user_workflow_group")){
            userPermissions.isEditUserWorkflow = true;
        }
        if(groups.some(group => group.name === "view_user_workflow_group")){
            userPermissions.isViewUserWorkflow = true;
        }
        if(groups.some(group => group.name === "edit_or_add_inventory_group")){
            userPermissions.isInventory = true;
        }
        if(groups.some(group => group.name === "accounting_group")){
            userPermissions.isAccountingGroup = true;
        }
        if(groups.some(group => group.name === "external_timecard_group")){
            userPermissions.isExternalTimecard = true;
        }
        if(groups.some(group => group.name === "expense_accounting")){
            userPermissions.isExpenseAccounting = true;
            userPermissions.isInternal = true;
        }
        if(groups.some(group => group.name === "expense_admin")){
            userPermissions.isExpenseAdmin = true;
            userPermissions.isExpenseAccounting = true;
            userPermissions.isExpenseInvoicing = true;
            userPermissions.isExpenseApproverOverride = true;
            userPermissions.isExpenseParticipation = true;
            userPermissions.isInternal = true;
        }
        if(groups.some(group => group.name === "expense_approver_override")){
            userPermissions.isExpenseApproverOverride = true;
            userPermissions.isInternal = true;
        }
        if(groups.some(group => group.name === "expense_participation")){
            userPermissions.isExpenseParticipation = true;
        }
        if(groups.some(group => group.name === "expense_invoicing")){
            userPermissions.isExpenseInvoicing = true;
            userPermissions.isExpenseParticipation = true;
            userPermissions.isInternal = true;
        }
        if(groups.some(group => group.name === "expense_client_view")){
            userPermissions.isExpenseClientView = true;
            userPermissions.isInternal = true;
        }
        // Back Office rollout gate. The group ships empty, so in practice
        // only dev/superuser (set below) reach the section until members
        // are added — no code change needed to widen it.
        if(groups.some(group => group.name === "back_office_group")){
            userPermissions.isBackOffice = true;
            userPermissions.isInternal = true;
        }
        // The requesting side only: file a request and watch your own. Kept
        // separate from back_office_group on purpose -- that group grants
        // full CRUD over the backlog, which a requester must not have.
        if(groups.some(group => group.name === "request_participation")){
            userPermissions.isBackOfficeRequest = true;
            userPermissions.isInternal = true;
        }
        if(groups.some(group => group.name === "view_engagements_invoices")){
            userPermissions.isViewEngagementsInvoices = true;
        }
        // Wider accounting role implies invoicing capability.
        if(userPermissions.isExpenseAccounting){
            userPermissions.isExpenseInvoicing = true;
        }
        if(userPermissions.isDev || userPermissions.isSuperuser){
            userPermissions.isBackOffice = true;
            userPermissions.isBackOfficeRequest = true;
            userPermissions.isExpenseApproverOverride = true;
            userPermissions.isExpenseParticipation = true;
            userPermissions.isExpenseInvoicing = true;
        }
        if(userPermissions.isBackOffice){
            userPermissions.isBackOfficeRequest = true;
        }
        // Derived: can the user reach the accounting pages?
        // Bypass roles (dev/superuser/expense admin) always pass; pure
        // accountants must also be in the expense_participation rollout.
        if(userPermissions.isDev || userPermissions.isSuperuser || userPermissions.isExpenseAdmin){
            userPermissions.canAccessExpenseAccounting = true;
        } else if(userPermissions.isExpenseAccounting && userPermissions.isExpenseParticipation){
            userPermissions.canAccessExpenseAccounting = true;
        }
        // The Accounting Queue page is reachable to anyone with full
        // accounting access OR to invoicing-only users (who see just
        // their two tabs there).
        userPermissions.canAccessAccountingQueue = (
            userPermissions.canAccessExpenseAccounting ||
            (userPermissions.isExpenseInvoicing && userPermissions.isExpenseParticipation)
        );
        // Standalone Client Expenses page — narrow read-only role
        // (expense_client_view) gets it, plus dev/superuser/admin.
        // Full accountants can also reach it from this link if they
        // want, though they already see the same data on the By
        // Client tab of the Accounting Queue.
        userPermissions.canAccessClientExpenses = (
            userPermissions.isDev || userPermissions.isSuperuser
            || userPermissions.isExpenseAdmin
            || userPermissions.isExpenseClientView
        );
        if(groups.some(group => group.name === "external_expense_only")){
            userPermissions.isExternalExpenseOnly = true;
        }
    }
    return userPermissions
}

function saveOfflineUser(user) {
    if (!isStandalone()) return
    localStorage.setItem('user', JSON.stringify({ id: user.id, groups: user.groups.map(group => ({ name: group.name })) }))
}

export default {
    async getToken(context, payload) {
        let userName = payload.username
        let fullName = ""
        let groups = null
        let userPermissions
        const response = await newLogin(userName, payload.password)
        // const result = await login(userName, payload.password)
        if(response && response.data && response.data.user) {
            if (response.data.user["first_name"] === undefined | response.data.user["last_name"] === undefined) {
              fullName = "User Full Name Not Defined"
            } else {
              fullName = response.data.user["first_name"] + ' ' + response.data.user["last_name"]
            }
            if (response.data.user["groups"].length == 0) {
                groups = null
            } else {
                groups = response.data.user["groups"]
                userPermissions = setUserPermissionsByGroup(response.data.user)
            }
            context.commit('setUser', {
                token: response.data.token,
                user: response.data.user,
                userGroups: groups,
                userPermissions: userPermissions,
                userFullName: fullName,
                username: userName,
                expiry: response.data.expiry
            })
            localStorage.setItem('token', response.data.token)
            localStorage.setItem('expiration', response.data.expiry)
            saveOfflineUser(response.data.user)
        }
        return response
    },
    async tryLogin(context, { path } = {}) {
        const token = localStorage.getItem('token');
        const tokenExpiration = localStorage.getItem('expiration');
        const expiresIn = new Date(tokenExpiration).getTime() - new Date().getTime();
        if (expiresIn < 0) {
            console.log('expired token')
            context.dispatch('logout')
            return 'expired token';
        }
        if(token){
            const response = await verifyToken(token)
            // const response = await verifyToken(token)
            let user = null
            if (response) {
                user = response.data["user"]
                saveOfflineUser(user)
            } else if (isStandalone() && path?.startsWith('/pwa') && localStorage.getItem('user')) {
                user = JSON.parse(localStorage.getItem('user'))
            }
            if(user) {
                let groups = user["groups"]
                let userPermissions
                let fullName = ''
                if (user["first_name"] === undefined | user["last_name"] === undefined) {
                    fullName = "User Full Name Not Defined"
                  } else {
                    fullName = user["first_name"] + ' ' + user["last_name"]
                  }
                  if (user["groups"].length == 0) {
                      groups = null
                  } else {
                    userPermissions = setUserPermissionsByGroup(user)
                  }
                context.commit('setUser', {
                    token: token,
                    user: user,
                    userGroups: groups,
                    userPermissions: userPermissions,
                    username: user.username,
                    userFullName: fullName,
                    expiry: tokenExpiration
                })
            } else {
                console.log('inactive token')
                // return
            }
            return response
        }
        return 'no token'
    },
    logout(context) {
        localStorage.removeItem('token')
        localStorage.removeItem('expiration')
        localStorage.removeItem('user')
        context.commit('setUser',{
            token: null,
            user: null,
            userGroups: null,
            userPermissions: null,
            userFullName: null,
            tokenExpiration: null
        })
        // if global timer set for expires in then clear it HERE
    },
    updateUser(context, payload) {
        context.commit('setUserName', {
            firstName: payload.first_name,
            lastName: payload.last_name,
            userFullName: `${payload.first_name} ${payload.last_name}`
        })
    }
}